import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DetailPage } from '../detail/detail';

@Component({
    selector: 'page-reference-results',
    templateUrl: 'reference-results.html'
})
export class ReferenceResultsPage {

    resultList: any;
    category: string;
    resultTotalCount: number;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.category = navParams.get('category');
        this.resultList = navParams.get('resultList');
        this.resultTotalCount = navParams.get('resultTotalCount');
    }

    /**
     * Pushes id and type to nav controller
     * @param {number} id
     * @param {string} type
     */
    getDetails(id: number, type: string) {
        this.navCtrl.push(DetailPage, {'objId': id, 'orgaStruct': type});
    }
}



// WEBPACK FOOTER //
// ./src/pages/reference-results/reference-results.ts